<template>
        <div class="row justify-content-center">
            
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-body px-lg-5 py-lg-5">
                       
                        <form role="form" v-if="recordar">
                             <p style="text-align: center;"><i class="fa fa-user text-sm text-gray pr-1"></i> {{ contacto.nombre }} {{ contacto.apellido }}</p>
                            <input type="hidden" v-model="objetoUser.email">
                            
                            <base-input class="input-group-alternative"
                                        placeholder="Contraseña"
                                        type="password"
                                        addon-left-icon="ni ni-lock-circle-open"
                                        v-model="objetoUser.pass">
                            </base-input>
                            <div class="text-center">
                                <base-button type="primary" class="my-2 btn-block" @click="loginPortal">Ingresar</base-button>
                            </div>
                            <div class="text-right">
                                <a class="my-4 text-xs" style="cursor: pointer" @click="limpiar"> Iniciar con otra cuenta</a>
                            </div>
                        </form>
                        
                        <form role="form" v-else>
                              
                            <base-input class="input-group-alternative mb-3"
                                        placeholder="Correo"
                                        addon-left-icon="ni ni-email-83"
                                        v-model="objetoUser.email">
                            </base-input>

                            <base-input class="input-group-alternative"
                                        placeholder="Contraseña"
                                        type="password"
                                        addon-left-icon="ni ni-lock-circle-open"
                                        v-model="objetoUser.pass">
                            </base-input>

                            <base-checkbox class="custom-control-alternative" v-model="isChecked">
                                <span class="text-muted" >Recuérdame</span>
                            </base-checkbox>
                            <div class="text-center">
                                <base-button type="primary btn-block" class="mt-4 mb-2" @click="loginPortal">Ingresar</base-button>
                            </div>
                            <div class="text-right">
                                <router-link class="my-2 text-xs" style="cursor: pointer" to="/recuperarpass"> ¿Olvidaste tu contraseña?</router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- <ba-login :company="company" :url="url"></ba-login> -->
            
        </div>
</template>

<style>
    .vue-notification {
        margin-top: 15px;
    }
</style>

<script>
import {mapState, mapMutations, mapGetters, mapActions} from 'vuex'
import store from '@/store'
import { log } from 'util'
// import { ba_login } from 'bea360component'

  export default {
    data() {
      return {
            isChecked: false,
            objetoUser:{
                company: process.env.VUE_APP_COMPANY,
                email: this.$store.getters['auth/recordar'] ? store.getters['auth/contacto'].email[0] : '',
                pass:'',
                url: process.env.VUE_APP_API_URL,
                checked: this.$store.getters['auth/recordar'] 
            },
        }
    },
    watch: {
        'objetoUser.checked': function(val) {
            if (val) {
                this.isChecked = this.$store.getters['auth/recordar'] 
            } else {
                this.isChecked = false
            }
        }
    },
    computed: {
        ...mapGetters('auth', ['recordar', 'contacto']),
        company(){
            return process.env.VUE_APP_COMPANY || "bea360"
        },
        url() {
            return process.env.VUE_APP_API_URL || "https://apidev.beaware360.com/ba360"
        }
    },
    methods: {
        ...mapActions('auth', ['login']),
        loginPortal() {
            this.objetoUser.checked = this.isChecked
            this.$store.dispatch('auth/login', (this.objetoUser))
                .then((res)=>{
                    this.$router.push({path: '/miscasos'})
                    this.$notify({
                        group: 'foo',
                        title: 'Mensaje',
                        type: 'success',
                        speed: 1000,
                        duration: 500,
                        text: 'Inicio de sesión exitosa!'
                    });
                })
                .catch(()=>{
                    console.log("llega catch")
                    this.$notify({
                        group: 'foo',
                        title: 'Mensaje',
                        type: 'error',
                        speed: 1000,
                        duration: 500,
                        text: 'No se ha podido iniciar sesión, intente nuevamente!'
                    });
                })
        },
        limpiar(){
            this.$store.dispatch('auth/limpiar')
        }
    }, 
    mounted() {
    
        // fetch('http://localhost:4000/typeView')
        //     .then(response => response.json())
        //     .then(data => console.log("ejemplo login portal", data));
    },
  }
</script>